module.exports = __webpack_public_path__ + "static/media/thevisualist.f7805356.png";